import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { logout as logoutAction } from '../../store/user/UserActions';
import { IUser } from '../../store/interface';
import { Container } from 'reactstrap';

import NavBar from '../../components/NavBar';

interface PropsFromState {
    route: any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    component: any
    logout: typeof logoutAction
    user: IUser
    login: any
    logged: any
    editProfile: any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


export default class SessionLayout extends Component<AllProps> {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        const Component = this.props.component;
        const route = this.props.route;
        const user = this.props.user;
        return (
            <Fragment>
                {/*
                <NavBar
                    editProfileButtonMethod={this.props.editProfile}
                    isAuthenticated={this.props.logged}
                    authButtonMethod={this.props.logged ? this.props.logout : this.props.login}
                    user={this.props.logged ? { name: user.name, displayName: user.name, email: user.name } : {}}
                ></NavBar>
                */}
                <main role="main" className="sessionMain">
                    <Container className="bg-light pb-3" fluid={true} >
                        <Component route={route} />
                    </Container>
                </main>
            </Fragment>
        );
    }
}